import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validators.acceptance',[Validator])
    .factory('acceptance', function(BCValidator) {
        function acceptance(value, instance, field) {
            if (not(value)) return true;
            return value === true;
        }

        function not(value) {
            if (value === false) return false;
            return !value;
        }

        acceptance.message = function() {
            return 'must be accepted.';
        };


        return new BCValidator(acceptance,'acceptance');
    }).name;
